import { AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, QueryList, Renderer2, TemplateRef, ViewChild, ViewChildren } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from 'src/app/shared/services/common.service';
import { InvestmentFundService } from '../../investment-fund.services';
import { AgGridService } from 'src/app/shared/common-components/ag-grid/ag-grid.service';
import { StorageService } from 'src/app/shared/services/storage.service';
import { DatePipe } from '@angular/common';
import { GridOptions, GridReadyEvent } from 'ag-grid-community';
import { NgForm } from '@angular/forms';
import { StorageName } from 'src/app/shared/enum/common-enum';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { PaymentSectionModel } from 'src/app/shared/common-components/payment-section/payment-section.model';
import { VoucherType, VoucherTypeName } from '../../../../../shared/models/common.model';
import { PaymentSectionComponent } from 'src/app/shared/common-components/payment-section/payment-section.component';
import { IconHover } from '../../../../../shared/enum/common-enum';
import { NotificationService } from '../../../../../shared/services/notification.service';
import { TransactionService } from '../../../transaction.service';
import { SelectPrintFormatPopupComponent } from '../../../../../shared/common-components/common-voucher/popup/select-print-format-popup/select-print-format-popup.component';
import { ModalPopupSize } from '../../../../../shared/models/common.model';
import { LoadDropdownDataComponent } from '../../../../../shared/common-components/load-dropdown-data/load-dropdown-data.component';
import { ReportService } from '../../../../report/report.service';

@Component({
  selector: 'app-receipt-popup',
  templateUrl: './receipt-popup.component.html',
  styleUrls: ['./receipt-popup.component.scss'],
  providers:[DatePipe],
})
export class ReceiptPopupComponent extends CommonService implements OnInit, AfterViewInit,OnDestroy{
  formName = StorageName.FORMNAME_TRANSACTION_INVESTMENT_LAYAWAYS_FUND;
  @ViewChild("receiptForm") receiptForm!: NgForm;
  @ViewChild(PaymentSectionComponent) paymentSectionComponent: PaymentSectionComponent;
  @ViewChild('alertContent') alertContent!: ElementRef;
  @ViewChild(LoadDropdownDataComponent) loadDropdownDataComponent: LoadDropdownDataComponent;
  formModel: any = {}
  currentHoverEffect = IconHover.Pink;
  @Input() data           : any;
  rdlcResourceName: any = "";
  notificationConfigurationModel : any = [];
  getAllDropdownModel  : any = {};
  paymentSectionModel     = new PaymentSectionModel();
  dropdownSettings                      : IDropdownSettings = {};
  TotalAmount                         = 0;
  gridApi:any
  private gridApis: any;
  columnApi:any
  receiptFormSubmit  : boolean = false;
  selectedMonthIds = []
  row=[];
  gridOptions: GridOptions = {};
  
  constructor(public ActiveModal:NgbActiveModal,
    public activeModal : NgbActiveModal,
    public storageService:StorageService ,
    public renderer : Renderer2,
    public agGridService : AgGridService , 
    public investmentFundService   : InvestmentFundService,
    public toaster: ToastrService,
    private datePipe: DatePipe,
    public storageservice: StorageService,
    public notificationService: NotificationService,
    public transactionService: TransactionService,
    public reportService: ReportService)
    {
      super(renderer);
    }
onGridReady(gridApi) {
  this.gridApis  = gridApi?.api;
  this.columnApi = gridApi?.columnApi;
}

checkMoreButton(): void {
  const allColumns = this.columnApi?.getAllColumns();
  const lastColumn = allColumns[allColumns?.length - 1];
  const lastColDef = lastColumn?.getColDef();
  const colDefs = allColumns?.map(column => column?.getColDef());
  const rowCount = this.gridApi.getDisplayedRowCount();
  const shouldShowMoreButton= this.TotalAmount== this.formModel?.amount?false :true;
  // Update header component params
  this.gridApi.setColumnDefs(colDefs.map(colDef => {
    if (colDef?.headerComponentParams && colDef?.headerName == '') 
    {
      colDef.headerComponentParams.moreaddButton = shouldShowMoreButton;
    }
    return colDef;
  }));
}
DropdownSettings: IDropdownSettings = {
  singleSelection: false,
  idField: 'id',
  textField: 'name',
  selectAllText: 'Select All',
  unSelectAllText: 'UnSelect All',
  itemsShowLimit: 3,
  allowSearchFilter: false,
};

ngOnInit(): void {
  if(this.data){
  this.formModel = this.data?.formModel;
  }
  this.data?.getDataModel;
  // this.schemeId;
  // this.installmentFundId;
  // this.installmentDate
  // this.receiptAmount
  this.data?.redemptionOn
  // this.formModel.goldRate= Number(this.formModel.goldRate == undefined ? 0.00 :this.formModel.goldRate)
  if (this.data?.redemptionOn !== 'Amount') {
    if (this.formModel?.amount && this.formModel?.goldRate) {
      const goldWt = this.formModel?.amount / this.formModel?.goldRate;
      const goldWtTotal = goldWt;
      // this.goldWt = goldWtTotal?goldWtTotal:0.000;
      this.formModel.goldWeight = goldWtTotal ? goldWtTotal.toFixed(3) : '0.000';
    }
}


  // this.entryByList
  const user = this.storageService.retrieve(StorageName.USER_INFO); 
  if ( this.formModel?.entryBy === undefined ||  this.formModel?.entryBy === null) {
    this.formModel.entryBy = user ? user?.id : null; 
  } 
  // this.entryByID=this.getDataModel.entryBy;
  const date = this.formModel?.installmentDate
  const dt =  this.datePipe?.transform(date, 'yyyy-MM-ddTHH:mm:ss');
  this.formModel.installmentDate = dt;
  if(this.data?.getDataModel. paymentMasterId)
  {
    this.getDataById(this.data?.getDataModel?.id,this.data?.getDataModel?.paymentMasterId)
  }else{
    this.removeMonth()
  }
  this.dataAdded()
// this.receiptAmount = this.receiptAmount.toFixed(2);
// this.goldRate = this.goldRate.toFixed(2);
this.initialCalls();
this.setVisibilityInstance();
 };
 ngAfterViewInit(): void {
    if(!this.data?.getDataModel?.paymentMasterId || this.data?.getDataModel?.paymentMasterId === 0){
    // const newRow = { paymentMethodId: null, depositeIntoId:null, transactionNo: '',chequeDate:null, amount:this.formModel.amount  };
    setTimeout(() => {
      // this.paymentSectionComponent.gridApi.api.applyTransaction({ add: [newRow] });
      let lastRowIndex = this.paymentSectionComponent?.gridApi?.api?.getLastDisplayedRow();
      let lastRowNode = this.paymentSectionComponent?.gridApi?.api?.getDisplayedRowAtIndex(lastRowIndex);
      var firstEditCol = this.paymentSectionComponent?.gridApi?.columnApi?.getAllDisplayedColumns()[0];
      this.paymentSectionComponent?.gridApi?.api?.setFocusedCell(lastRowNode?.rowIndex, firstEditCol?.getColId());
      this.paymentSectionComponent?.gridApi?.api?.startEditingCell({
        rowIndex: lastRowNode?.rowIndex,
        colKey: firstEditCol?.getColId(),
      });
      this.paymentSectionComponent.TotalAmount = this.formModel?.amount ?? 0;
    }, 100);
  }

 }
 cellValueChanged(gridApi){
  this.paymentSectionComponent.calculateTotalAmount(gridApi)
 }
 initialCalls()
 {
   this.formModel.voucherType = VoucherTypeName.ReceiptVoucher;
   this.formModel.invoiceModel = {};
   this.formModel.invoiceModel.voucherTypeId = VoucherType.ReceiptVoucher;
 }
 setVisibilityInstance(){
  this.paymentSectionModel.setVisibility(StorageName.INVESTMENT_FUND_INSTALLMENT_ENTRY_RECEIPT_GRID,false);
}
 
 dataAdded(){
  this.agGridService.nextRowAdded.subscribe((event=>{
    if(event){
    setTimeout(() => {
     let  allNode
      const allNodes =  this.gridApis?.getModel()?.rowsToDisplay?.map(a => a?.data);
      if(allNodes?.length >1 ){
         allNode = this.gridApis?.getDisplayedRowAtIndex(allNodes?.length - 1); 
      }
      if (allNode) {
        const remainingAmount = this.formModel?.amount - this.TotalAmount;
        if (remainingAmount >= 0) {
          allNode.setDataValue('amount', remainingAmount);
        } else {
          allNode.setDataValue('amount', );
        }
      }
    }, 100);
    }
    
  }))
 }
 selectedpaymentDate(event){
  this.formModel.paymentDate = event;
 }
 selecteIntallmentDate(event){
  this.formModel.installmentDate = event;
 }

 getDataById(id , paymentMasterId){
  this.investmentFundService.getReceiptData(id , paymentMasterId).subscribe((res) =>{
    if(res?.isSuccess){
      this.formModel =  res?.response;
      if(!this.formModel?.invoiceModel) this.formModel.invoiceModel ={};
      this.formModel.invoiceModel.voucherTypeId = VoucherType.ReceiptVoucher;
      this.formModel?.paymentList.forEach(payment => {
        payment.depositeIntoId = payment?.depositeIntoId?.toString(); 
      });
      setTimeout(() => {
        this.paymentSectionComponent?.gridApi?.api?.setRowData( this.formModel?.paymentList);
        this.paymentSectionComponent.isShowFooterRow = true;
        this.paymentSectionComponent.calculateTotalAmount(this.formModel?.paymentList ,true);
        this.multipleMonthId(res?.response?.multipleInstallmentDates)
        this.checkMoreButton();
      }, 100);
    }
  })
 }
 removeMonth(){
  let updatedList = this.data?.monthList
  let formattedDates = updatedList.flatMap(item => 
    item?.split(',').map(date => date?.trim())
  );
   this.data.monthDropdownList = this.data?.monthDropdownList.filter(item => {
    return !formattedDates.some(date => item?.name.includes(date));
  });
 }
 multipleMonthId(dateString: string) {
  let datesToRemove = dateString?.split(',').map(date => date.trim());
  const flattenedDates = this.data?.monthList.flatMap(item => item?.split(',').map(date => date.trim()));
  let updatedList = flattenedDates.filter(date => !datesToRemove.includes(date));
  let formattedDates = updatedList.flatMap(item => item?.split(',')?.map(date => date.trim()));
  this.data.monthDropdownList = this.data?.monthDropdownList?.filter(item => {
    return !formattedDates.some(date => item?.name.includes(date));
  });
  const targetDates = dateString.split(',').map(date => date.trim());
  const foundItems = this.data?.monthDropdownList?.filter(item =>
    targetDates.some(targetDate => targetDate?.includes(item.name))
  );
  if (foundItems.length > 0) {
    this.selectedMonthIds = foundItems?.map(item => ({
      id: item?.id,
      name: item?.name
    }));
  } else {
    this.selectedMonthIds = [];
  }
}

  onCellValueChange(event) {
    this.TotalAmount
  }

  onKeydown(event) {
    const goldWt = this.formModel?.amount / Number(this.formModel?.goldRate);
    const goldWtTotal = goldWt == Infinity ? 0 : goldWt;
    this.formModel.goldWeight = `${goldWtTotal.toFixed(3)}`;
  }

  onGridProdutListReady(params: GridReadyEvent) {
    this.gridApi = params.api;
  }
  getDataBuSchemeID(event) {
    const id = Number(event)
    this.formModel.entryBy = id
  }

   onPrint(isPrint) {
      this.formModel.isPrint = isPrint;
      this.formModel.invoiceModel.sendNotification = true;
      if(!this.isBlankUndefinedOrNull(this.formModel?.invoiceModel?.id))
      {
        this.notificationService.confirmationPopup("Notification Confirmation", "Do You want to send e-mail/whatspp?", 'printBill').subscribe((result) => {
          if(!result.isConfirmed) 
            this.formModel.invoiceModel.sendNotification = false;
          this.processToInsertInvoiceData();
        });
      }
      else
      this.processToInsertInvoiceData();
      
    }
    //#endregion
    
    processToInsertInvoiceData() {
      const voucherTypeId = this.formModel?.invoiceModel?.voucherTypeId;
      this.transactionService.getSettingsAndRDLCTemplate(this.formModel?.isPrint, null, voucherTypeId, (printFormatData) => {
        if (printFormatData) {
          this.openSelectPrintFormatPopup(printFormatData);
        } else {
          this.saveReceiptData();
        }
      });
    }
    
    openSelectPrintFormatPopup(printFormatData: any){
     var data = {printFormatData : printFormatData, modalTitle : 'Select Print Format'}
     this.notificationService.openModalPopup(SelectPrintFormatPopupComponent,data,undefined,ModalPopupSize.MD,'',false,true).then(
      (result)=>{
        if (result) {
          const componentInstance = result?.componentInstance;
          this.rdlcResourceName = componentInstance?.rdlcResourceName;
          this.saveReceiptData();
        }
      }
     )
    }


  saveReceiptData() {
    console.log(this.paymentSectionComponent.TotalAmount );
    
      if (this.paymentSectionComponent?.TotalAmount === 0){
        this.toaster.error('Paid amount cannot be 0')
      }
      else {
      this.receiptFormSubmit = true;
      if (this.receiptForm?.valid) {
        this.formModel?.paymentMasterId ? this.updateinstallmentfundentries() : this.insertinstallmentfundentries();
      }
    }
  }
  
  onDeletePaymentClick(params) {
    this.paymentSectionComponent.isShowFooterRow = true;
    this.paymentSectionComponent.calculateTotalAmount(this.formModel?.paymentList ,true);
  }

insertinstallmentfundentries() 
{
  if(Array.isArray(this.formModel?.multipleInstallmentDates)){
      this.formModel.multipleInstallmentDates = this.formModel?.multipleInstallmentDates?.join(', ');}

  this.investmentFundService.insertinstallmentfundentries(this.formModel).subscribe({ next:(res)=>{
    if (res?.isSuccess) {
      this.activeModal.close(res?.isSuccess);
      this.toaster.success(res?.message);
      this.reportService.processResponse(res, this.formModel?.invoiceModel, this.notificationConfigurationModel, this.formModel?.isPrint, undefined, this.rdlcResourceName,true)
    }
  },error:(err)=>{
    this.toaster.error(err?.error?.message)
  }
})
}
updateinstallmentfundentries() 
{
  if(Array.isArray(this.formModel?.multipleInstallmentDates)){
    this.formModel.multipleInstallmentDates = this.formModel?.multipleInstallmentDates?.join(', ');}

  this.investmentFundService.UpdateInstallmentFundEntries(this.formModel).subscribe((res) => {
    if (res?.isSuccess) {
      this.activeModal.close(res?.isSuccess);
      this.toaster.success(res?.message);
      this.reportService.processResponse(res, this.formModel?.invoiceModel, this.notificationConfigurationModel, this.formModel?.isPrint, undefined, this.rdlcResourceName,true)
    }
  })
}


onMonthSelect(data,selectAll) {
  this.formModel.multipleInstallmentDates = [...data];
  if(!selectAll){
    this.selectedMonthIds = [...data];
  }
  this.formModel.amount = this.data?.ammount * ((data?.length > 0) ? data?.length : 1);
  this.TotalAmount = this.formModel?.amount;
 // this.paymentSectionComponent.TotalAmount = this.TotalAmount;
  const allNodes = this.gridApis?.getModel()?.rowsToDisplay?.map(a => a?.data);
  let allNode
  if (allNodes?.length > 0) {
    allNode = this.gridApis?.getDisplayedRowAtIndex(allNodes?.length - 1);
  }
  if (allNode) {
    allNode.setDataValue('amount', this.TotalAmount);
  }
}

  ngOnDestroy(): void {
  }
}
